import { useApiServiceCallback } from "./client";
import { WorkerApiService } from "./worker";

import type { Workers } from "../../utils/service-url";
import type { ApiResponse } from "./client";
import type { Client, UnsplashApi } from "unsplash-js";

type ExtractPaths<T> = T extends Client<infer P, never> ? P : never;
type UnsplashPaths = ExtractPaths<UnsplashApi>;
type Search =
  UnsplashPaths["/search/photos"]["get"]["responses"]["200"]["content"]["application/json"];
type Photo = UnsplashPaths["/photos"]["get"]["responses"]["200"]["content"]["application/json"][0];
type Orientation = UnsplashPaths["/search/photos"]["get"]["parameters"]["query"]["orientation"];
export class UnsplashService extends WorkerApiService {
  module = "unsplash" as const satisfies Workers;

  async search(
    query: string,
    orientation?: Orientation,
  ): Promise<
    ApiResponse<{
      photos: Search;
    }>
  > {
    const settings = new URLSearchParams();
    settings.set("query", query);
    if (orientation) settings.set("orientation", orientation);

    return await this.get(`search?${settings.toString()}`);
  }

  async ackDownload(url: string): Promise<ApiResponse<{ success: boolean }>> {
    return await this.post("download", { url });
  }

  async getId(id: string): Promise<
    ApiResponse<{
      full: Photo;
    }>
  > {
    return await this.get(`get/${id}`);
  }
}

export const useUnsplashSearch = (): ((
  query: string,
  orientation: Orientation,
) => Promise<
  ApiResponse<{
    photos: Search;
  }>
>) =>
  useApiServiceCallback(
    UnsplashService,
    async ({ apiService }, query: string, orientation: Orientation) =>
      await apiService.search(query, orientation),
    [],
  );
